import React from 'react';
import { useDispatch } from 'react-redux';
import * as Icon from 'react-feather';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

import ConferenceCallDetail from './ConferenceCallDetail';
import { convertToMask } from '../../../utils/common';

import {
  setCallEnd,
  setCallNumber,
  setScreenType,
  useCallNumber,
  useConferenceDetail
} from '../../../store/slices/dialSlice';
import { useUserDetails } from '../../../store/slices/authSlice';

const ConferenceLiveScreen = ({ number, setNumber }) => {
  const user = useUserDetails();
  const callNumber = useCallNumber();
  const conferenceDetail = useConferenceDetail();

  const dispatch = useDispatch();

  return (
    <div className="h-100 call-action-btn-container">
      {conferenceDetail && conferenceDetail?.details?.length > 0 ? (
        <ConferenceCallDetail isLoading={false} number={number} />
      ) : (
        <div className="mt-auto mb-auto text-white text-center fw-bold fs-4">
          {user?.process_details?.numberMasking === 'true'
            ? convertToMask(callNumber || number)
            : callNumber || number}
        </div>
      )}
      <div className="text-center conference-call-button-grid text-white mt-auto pb-4">
        <div className="d-flex justify-content-center">
          <Button
            className="back-button bg-white"
            onClick={() => {
              dispatch(setScreenType('CONFERENCE'));
            }}>
            <Icon.UserPlus className="back-icon text-primary" />
          </Button>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            className="back-button bg-danger"
            onClick={() => {
              dispatch(setCallEnd(true));
              setNumber('');
              dispatch(setCallNumber(''));
              dispatch(setScreenType(null));
            }}>
            <Icon.PhoneCall className="back-icon text-white" />
          </Button>
        </div>
      </div>
    </div>
  );
};

ConferenceLiveScreen.propTypes = {
  number: PropTypes.string,
  setNumber: PropTypes.func
};

export default ConferenceLiveScreen;
